/* eslint-env browser, es6 */

export function setResultsUrl(duelId: string) {
  window.history.pushState({}, "", `/webble/r/${duelId}`);
}

export function setHomeUrl() {
  window.history.pushState({}, "", "/webble");
}
